import Api from "@/services/api";
import { Template, TemplatesFilterDtoIn, TemplateInfo } from "./types";

export async function getAllTemplates(): Promise<Array<Template>> {
    return new Promise((resolve, reject) => {
        Api.get("/template/").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFilteredTemplates(model: TemplatesFilterDtoIn): Promise<Template[]> {
    return new Promise((resolve, reject) => {
        Api.post("/template/filter", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getTemplate(id: string): Promise<Template> {
    return new Promise((resolve, reject) => {
        Api.get(`/template/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createTemplate(model: Template): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/template", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateTemplate(model: Template): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/template", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteTemplate(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/template/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/template/checkDelete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function GetTemplateInfo(id: string): Promise<TemplateInfo> {
    return new Promise((resolve, reject) => {
        Api.get(`/template/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function copyTemplate(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post(`/template/copy/${id}`, null).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
